import { useContext } from "react";
import { AuthContext } from "../../Router/hox/AuthProvider";


export function useAuth(){
    return useContext(AuthContext);
}

